import React from 'react';
import { Handle, Position } from 'reactflow';
import { StopCircle } from 'lucide-react';

const EndNode = ({ data }) => {
  return (
    <div className="bg-red-100 border-2 border-red-400 rounded-lg p-4 min-w-[200px]">
      <Handle 
        type="target" 
        position={Position.Top} 
        className="!w-4 !h-4 !bg-red-500 !border-2 !border-white"
        style={{ top: -8 }}
      />
      <div className="flex items-center gap-2 mb-2">
        <StopCircle size={20} className="text-red-600" />
        <div className="font-semibold text-red-900">End Flow</div>
      </div>
      <div className="text-sm text-red-700">
        Flow ends here
      </div>
    </div>
  );
};

export default EndNode;
